import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import { states } from 'states';
import { Validators } from 'utils/Validators';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';

import {
  RentalActivityStateValues,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<keyof RentalActivityStateValues | any>[] = [
  {
    name: 'doesTheLlcOwnTheRentalProperty',
    label: 'Does the LLC own the rental property?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        dependenciesTitle:
          'Please describe all rental properties you owned this year',
        predicate: (v) => v === 'yes',
        name: 'rentalPropertyList',
        label: 'Rental Properties',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'whatTypeOfPropertyIsThisRentalProperty',
            label: 'What type of property is this rental property?',
            type: 'select',
            options: [
              {
                label: 'Single-family Residence',
                value: 'Single-family Residence',
              },
              {
                label: 'Multi-family Residence',
                value: 'Multi-family Residence',
              },
              {
                label: 'Commercial Building',
                value: 'Commercial Building',
              },
              {
                label: 'Vacation Home/Short-term Rental',
                value: 'Vacation Home/Short-term Rental',
              },
              {
                label: 'Land',
                value: 'Land',
              },
              {
                label: 'Other',
                value: 'Other',
              },
            ],
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,

            dependencies: [
              {
                name: 'otherDescription',
                label: 'Please describe',
                type: 'text',
                effect: updateKeyInStore(updateKey),
                comment: true,
                predicate: (v) => v === 'Other',
              },
            ],
          },
          {
            dependenciesTitle: 'What is the address of this rental Property',
            name: 'streetAddress',
            label: 'Street Address',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'city',
            label: 'City',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'state',
            label: 'State',
            type: 'state',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'zipCode',
            label: 'Zip code',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'country',
            label: 'Country',
            type: 'country',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'datePropertyWasPurchased',
            label: 'Date property was purchased',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            predicate: (v) => v === 'no',

            comment: true,
          },
          {
            name: 'purchasePrice',
            label: 'Purchase price',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            predicate: (v) => v === 'no',

            comment: true,
          },
          {
            name: 'daysRentedInTaxYear',
            label: 'Days rented in tax year',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'datePropertyBeganBeingRented',
            label: 'Date property began being rented',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'doYouHaveAPriorDepreciationScheduleifFiledPreviousTaxReturn',
            label:
              'Do you have a prior depreciation schedule? (if filed previous tax return)',
            type: 'radio',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                tooltip: '',
                comment: true,
                name: 'pleaseUploadACopyOfPriorDepreciationSchedule',
                label: 'Please upload a copy of Prior Depreciation Schedule.',
                type: 'upload',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'yes',
              },
            ],
          },

          {
            name: 'ifNoRentalIncomeWasEarnedInTaxYearWasPropertyAvailableToBeRented',
            label:
              'If no rental income was earned in tax year, was property available to be rented?',
            type: 'radio',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'datePropertyWasAvailableToBeRentedOut',
                label: 'Date property was available to be rented out',
                type: 'date',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'yes',
              },
            ],
          },

          {
            name: 'wasThisPropertySoldThisYear',
            label: 'Was this property sold this year?',
            type: 'radio',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'pleaseUploadACopyOfTheHudClosingStatement',
                label: 'Please upload a copy of the HUD closing statement.',
                type: 'upload',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'yes',
                comment: true,
              },
            ],
          },
          {
            name: 'didYouHaveAProfessionalAtAccountantsOnAirPrepareFinancialStatementsForThisPropertyThisYear',
            label:
              'Did you have a professional at Accountants On Air prepare financial statements for this property this year?',
            type: 'radio',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'congratulationsThatMeansMuchLessWorkForYouOnThisTaxInformationweWillImportYourFinancialStatementsDirectlyFromOurBookkeepingSoftware',
                label:
                  'Congratulations! That means much less work for you on this tax information!\nWe will import your financial statements directly from our bookkeeping software.',
                type: 'information',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'yes',
              },
              {
                name: 'pleaseIncludeYourYearRevenuesAndExpensesForThisRentalPropertyBelow',
                label:
                  'Please include your {year} revenues and expenses for this rental property below',
                type: 'information',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },
              {
                name: 'rentsReceived',
                label: 'Rents received',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },
              {
                dependenciesTitle: 'Expenses',
                name: 'cleaningAndMaintenance',
                label: 'Cleaning and maintenance',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',
                comment: true,
              },

              {
                name: 'commissions',
                label: 'Commissions',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'insurance',
                label: 'Insurance',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'legalAndOtherProfessionalFees',
                label: 'Legal and other professional fees',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'mangementFees',
                label: 'Mangement fees',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'mortgageInterestPaidToBanksEtc',
                label: 'Mortgage interest paid to banks, etc',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'otherInterest',
                label: 'Other interest',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'repairs',
                label: 'Repairs',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'supplies',
                label: 'Supplies',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'taxes',
                label: 'Taxes',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'travel',
                label: 'Travel',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },

              {
                name: 'utilities',
                label: 'Utilities',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',

                comment: true,
              },
              {
                name: 'otherExpensesList',
                label: 'Other Expenses',
                type: 'fieldArray',
                dependencies: [
                  {
                    name: 'name',
                    label: 'Name',
                    type: 'text',
                    effect: updateKeyInStore(updateKey),
                    tooltip: '',
                    comment: true,
                  },
                  {
                    name: 'amount',
                    label: 'Amount',
                    type: 'number',
                    effect: updateKeyInStore(updateKey),
                    tooltip: '',
                    comment: true,
                  },
                ],
                defaultDependency: {},
                effect: (payload) =>
                  store.dispatch(updateFieldArrayKey(payload)),
                predicate: (v) => v === 'no',
              },
              {
                name: 'totalExpenses',
                label: 'Total Expenses',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',
              },
              {
                name: 'profitloss',
                label: 'Profit/Loss',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'no',
              },
            ],
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({
  rentalPropertyList: Yup.array().of(
    Yup.object().shape({
      zipCode: Validators.zipCode,
    }),
  ),
});
